import React from 'react';
import type { FC } from 'react';
import kebabCase from 'lodash/kebabCase.js';
import { TextInput } from '@wix/cli-ui-kit';
import { getSiteWidgetExtensionsDir } from '@wix/cli-astro-definitions';
import { useWizardStep } from '../Wizard.js';
import {
  useReactComponentFolderValidation,
  useReactComponentNameValidation,
} from '../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../bi/index.js';
import { useProjectModel } from '../../../model.js';

export const ChooseComponentNameStep: FC<{
  componentName?: string;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, componentName }) => {
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();
  const validateName = useReactComponentNameValidation();

  return (
    <TextInput
      isActive={isActive}
      label={'Enter a name for your component:'}
      placeholder={componentName ?? 'My Component'}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'Enter a name for your component:',
          questionKey: 'generate_command.react_component.choose_name',
          answer: value,
          additionalInfo: { extensionType: 'site component' },
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateName}
    />
  );
};

export const ChooseComponentFolderStep: FC<{
  componentName?: string;
  componentFolder?: string;
  onSubmit: (componentFolder: string) => void;
}> = ({ onSubmit, componentFolder, componentName }) => {
  const { model } = useProjectModel();
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();
  const defaultComponentFolder = kebabCase(componentName);
  const validateComponentFolder = useReactComponentFolderValidation(
    getSiteWidgetExtensionsDir(model.projectFolder)
  );

  return (
    <TextInput
      isActive={isActive}
      label={'Enter the folder for the new component:'}
      placeholder={componentFolder ?? defaultComponentFolder}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'Enter the folder for the new component:',
          questionKey: 'generate_command.react_component.choose_folder',
          answer: value,
          additionalInfo: { extensionType: 'react component' },
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateComponentFolder}
    />
  );
};
